import React from 'react';
import * as Sentry from '@sentry/nextjs';

import { useAuth } from '@strongio/pretrained-dashboard/auth';

export default function ErrorBoundary({ ...props }) {
  const { getUser } = useAuth();

  props.showDialog = true;
  props.fallback = /*#__PURE__*/React.createElement("p", { className: "text-sm text-gray-500" }, "A client-side exception has occurred");

  const profile = getUser();
  if (profile) {
    props.dialogOptions = {
      user: {
        email: profile.email,
        name: profile.displayName } };


  }

  return /*#__PURE__*/(
    React.createElement(Sentry.ErrorBoundary, props));

}